import React from "react";
import { GridLayout, InfiniteGridProps } from "@egjs/react-infinitegrid";
import IrregularItem, { Props as ItemProps } from "./IrregularItem";

export interface IrregularList
  extends Pick<ItemProps, "languageCode" | "project" | "onClickItem"> {}

export interface IrregularItem
  extends Pick<ItemProps, "onClickItem" | "languageCode"> {}

interface Props {
  list: IrregularList[];
  gridLayoutProps: InfiniteGridProps;
}

const IrregularListView = ({ list, gridLayoutProps }: Props) => (
  <GridLayout {...gridLayoutProps}>
    {list.map((item, index) => (
      <IrregularItem key={index} groupKey={1} {...item} />
    ))}
  </GridLayout>
);

export default IrregularListView;
